import __request__ from 'routing/request';
/**
 * Return an overview of all grants in the system
 */
export function getOverview(): Promise<unknown> {
    return __request__('GET', '/authz/grants-overview', null, {}, {
        'Accept': ['application/json']
    });
}
